






































































import Vue from "vue";
import iwPackPricing from "@/optimizedEncoding/components/packSelection/PackPricing.vue";
import iwResultsGuaranteeNotice from "@/shared/components/pricing/ResultsGuaranteeNotice.vue";
import iwPackInfoModal from "@/shared/components/pricing/PackInfoModal.vue";
import iwNextPreviousButton from "@/encoding/components/NextPreviousButton.vue";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { Classified } from "@/shared/interfaces/classified/Classified.interface";
import datetimeMixin from "@/shared/mixins/datetimeAttribute";
import { mapActions, mapState } from "vuex";
import { WizardState } from "@/shared/interfaces/WizardState.interface";
import { OptimizedPack } from "@/shared/interfaces/optimizedEncoding/PackSelection.interface";
import { OrderApiError } from "@/shared/interfaces/order/Order.interface";
import missingCustomerNameMixin from "@/shared/mixins/missingCustomerName";

export default missingCustomerNameMixin.extend({

    name: "VisibilityUpgradeSelection",

    components: {
        iwResultsGuaranteeNotice: iwResultsGuaranteeNotice,
        iwPackPricing: iwPackPricing,
        iwPackInfoModal: iwPackInfoModal,
        iwNextPreviousButton: iwNextPreviousButton,
    },

    mixins: [datetimeMixin],

    props: {
        classified: {
            type: Object,
            required: false,
            default: {} as Classified
        },
    },

    data: function() {
        return {
            pathInStore: "transaction.pricing",
            configuredPacksInStore: "transaction.configuredPacks",
            selectedPackageInStore: "publication.visualizationOption",
            isMobile: true,
            isButtonDisabled: false as boolean,
            validationChecking: false,
            packInfoType: null as string | null,
        };
    },
    computed: {
        ...mapState("StepsWizard", {
            currentStep: state => (state as WizardState).current,
        }),
        publishedPackage: function(): string {
            return this.classified?.publication.visualizationOption;
        },
        selectedPackage: function(): string {
            return this.$store.getters["FormModule/getValueTransaction"](this.selectedPackageInStore);
        },
        packs: function(): Record<string, Record<string, unknown>> {
            return this.$store.getters["FormModule/getValueTransaction"](this.pathInStore);
        },
        configuredPacks: function(): Array<OptimizedPack> {
            return this.$store.getters["FormModule/getValueTransaction"](this.configuredPacksInStore) || [];
        },
        visiblePacks: function(): Array<OptimizedPack> {
            const tierOrder: Record<string, number> = { basic: 0, classic: 1, premium: 2 };
            const currentTier = tierOrder[this.publishedPackage?.toLowerCase()] ?? 0;
            return this.configuredPacks.filter(pack => {
                const packTier = tierOrder[pack.packType] ?? 0;
                return packTier >= currentTier;
            });
        },

        expirationDate: function(): Date|null {
            const date = this.classified?.expirationDate;
            if (date) {
                return (new Date(date));
            }

            return null;
        },

        daysLeft: function(): number|null {
            if (!this.expirationDate) { return null; }

            const expiration = this.expirationDate.getTime();
            const now = (new Date()).getTime();
            const diff = (expiration - now) / (1000 * 3600 * 24);

            return Math.ceil(diff);
        },
        isUpgradePackSelected: function(): boolean {
            return this.visiblePacks.some(pack => pack.title === this.selectedPackage);
        },
        packsGridStyle: function(): Record<string, string> {
            const cols = this.visiblePacks.length;
            const maxWidthPerCol = 340;
            return {
                "--upgrade-pack-cols": String(cols),
                "max-width": `${cols * maxWidthPerCol}px`,
            };
        },
        hideAndDisablePreviousButton: function(): boolean {
            return this.currentStep.step === "visibility-upgrade-choice";
        },

        automaticDiscount: function(): { id: string; value: number } | null {
            const discount = this.$store.getters["FormModule/getValueUI"]("transaction.pack.automaticDiscount");
            if (discount && discount.value) {
                return discount;
            }
            return null;
        },

        discountBannerText: function(): string {
            if (!this.automaticDiscount) return "";
            const campaignKey = this.automaticDiscount.id.toLowerCase() + "_title";
            const params = { value: Math.abs(this.automaticDiscount.value) };
            if (this.$te(campaignKey)) {
                return this.$t(campaignKey, params) as string;
            }
            return this.$t("automatic_discount_banner", params) as string;
        },

    },

    mounted: function() {
        this.$responsive.registerMediaQuery("from-medium", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });
    },

    methods: {
        ...mapActions({
            goToPreviousStep: "StepsWizard/previous",
            goToNextStep: "StepsWizard/next",
        }),
        ...mapActions("OrdersModule", ["createOrder", "createTransaction"]),
        openPackInfoModal: function(packType: string) {
            this.packInfoType = packType;
        },
        closePackInfoModal: function() {
            this.packInfoType = null;
        },
        clickNext: function(){
            // IO-154: creating the order emits the B2C log to Salesforce, so the name has to be
            // usable first. Placed before the flags below so no reset is needed.
            if (this.blockOnMissingCustomerName(this.clickNext)) {
                return;
            }

            this.validationChecking = true;
            this.isButtonDisabled = true;
            // Select package
            this.createOrder({
                classified: this.classified,
                type: "UPGRADE",
                errorRoute: "visibility-upgrade-payment",
            }).then(success => {
                this.validationChecking = false;
                this.isButtonDisabled = false;
                if (!success) { return false; }
                this.goToNextStep();
            }).catch(error => {
                this.validationChecking = false;
                this.isButtonDisabled = false;
                if (this.openModalOnMissingCustomerNameError(error, this.clickNext)) {
                    return;
                }
                this.dialog.alert(this.getOrderCreationErrorMessage(error));
                console.error(error);
            });
        },
        clickPrevious: function(){
            this.goToPreviousStep();
        },
        getOrderCreationErrorMessage: function(errors: Array<OrderApiError> = []): string {
            const hasBillingAddressError = errors.some((error: OrderApiError) =>
                error?.dataPath === "customer.location.address.provided"
            );

            if (hasBillingAddressError) {
                return this.$t("billboard_complete_billing_address_required") as string;
            }

            return i18n.t("server_not_responding_error").toString();
        },
    },
});

